'use client';

import * as React from 'react';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { DateRange, DayPickerRangeProps } from 'react-day-picker';
import { cn } from '../../utils/tailwind';
import { Calendar, Popover, PopoverContent, PopoverTrigger } from '../';
export type DatePickerWithRangeProps = {
  children?: ReactNode;
  calendarProps?: Partial<Omit<DayPickerRangeProps, 'mode'>>;
  className?: string;
  dateRange: DateRange | undefined;
  setDateRange: Dispatch<SetStateAction<DateRange | undefined>>;
  footer?: ReactNode;
  onPopOverOpenChange?: (open: boolean) => void;
};
export function DateRangePicker({
  children,
  className,
  dateRange,
  setDateRange,
  calendarProps,
  footer,
  onPopOverOpenChange
}: DatePickerWithRangeProps) {
  return <div className={cn('grid gap-2', className)} data-sentry-component="DateRangePicker" data-sentry-source-file="DateRangePicker.tsx">
      <Popover onOpenChange={onPopOverOpenChange} data-sentry-element="Popover" data-sentry-source-file="DateRangePicker.tsx">
        <PopoverTrigger asChild data-sentry-element="PopoverTrigger" data-sentry-source-file="DateRangePicker.tsx">{children}</PopoverTrigger>
        <PopoverContent className="w-auto overflow-hidden p-0" align="end" data-sentry-element="PopoverContent" data-sentry-source-file="DateRangePicker.tsx">
          <Calendar initialFocus mode="range" defaultMonth={dateRange?.from} numberOfMonths={2} selected={dateRange} onSelect={setDateRange} {...calendarProps} data-sentry-element="Calendar" data-sentry-source-file="DateRangePicker.tsx" />
          {footer}
        </PopoverContent>
      </Popover>
    </div>;
}